﻿﻿import { IProductCenter } from './product-center';
import { ICenter } from './center';
import { IContact } from './contact';
import { IUser } from './user';
import { ICommunicationLogContact } from './communication-log-contact';
import { ICommunicationLogNotes } from './communication-log-notes';

export interface ICommunicationLog {
    id: number;
    productCenter: IProductCenter;
    center: ICenter;
    communicationContact: IContact;
    reportedByContact: IContact;
    logDateTime: string;
    summary: string;
    notes: string;
    createdBy: number;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
    createdByUser: IUser;
    updatedByUser: IUser;
    contacts: ICommunicationLogContact[];
    additionalNotes: ICommunicationLogNotes[];
}
